import { useState } from "react";
import { format_number } from "../../../utilities/ext-function";
import SimpleBar from "simplebar-react";

const ITEMS_PER_PAGE = 4; // Jumlah data per halaman

export default function BroadcastPanelTable({ dataBroadcast }) {
  const [currentPage, setCurrentPage] = useState(1);

  // Hitung jumlah halaman
  const totalPages = Math.ceil(dataBroadcast.length / ITEMS_PER_PAGE);

  // Ambil data yang sesuai dengan halaman saat ini
  const paginatedData = dataBroadcast.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div
      className="d-flex justify-space-between"
      style={{
        minHeight: "180px",
        flexDirection: "column",
      }}
    >
      <SimpleBar style={{ minHeight: "180px", overflowY: "auto" }}>
        <table className="table table-striped">
          <tbody>
            {paginatedData.map((item, index) => {
              // Hitung persentase progress
              const percentage =
                item.target_total > 0
                  ? (item.target_processed / item.target_total) * 100
                  : 0;
              return (
                <tr key={index}>
                  <td className="pt-2 pb-2">{item.name}</td>
                  <td className="pt-2 pb-2 w-50">
                    <div className="progress">
                      <div
                        className="progress-bar bg-orange"
                        role="progressbar"
                        style={{ width: `${percentage}%` }}
                        aria-valuenow={percentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {Math.round(percentage)}%
                      </div>
                    </div>
                  </td>
                  <td align="right" className="pt-2 pb-2">
                    {format_number(item.target_processed)}/
                    {format_number(item.target_total)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </SimpleBar>

      {/* Pagination */}
      {dataBroadcast.length > 4 && (
        <div className="d-flex justify-content-center gap-2">
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#293042", color: "#fff" }}
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#293042", color: "#fff" }}
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
